module.exports = __webpack_public_path__ + "static/media/DJ.556d36ea.svg";